export const SYNONYM_SHOW_ALL_THRESHOLD = 20
export const RANGE_MOBILE_MORE_THRESHOLD = 7

export const APPOINTMENT_SOURCE = 'lpu-inner'

/** Сколько дней слотов запрашивает запись на услугу. */
export const DAYS_FOR_SERVICE_SLOTS = 14

export const SERVICE_SLOT_GOAL = {
  CLICK_LIST_DIRECT: 'appointment__clickServiceListSlotDirect',
  CLICK_PRICE_LIST_DIRECT: 'appointment__clickSlotServicePriceListDirect',
  CONFIRM_REFERRAL: 'appointment__serviceClickConfirmReferral',
  CONFIRM_PRELIMINARY: 'appointment__serviceClickConfirmPreliminaryConsultation',
} as const
